<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row" style="padding:0px 15px">
        <div class="col-xl-8">
          <div class="row bg_white">
            <div class="col-xl-4 col-md-6 card_margin">
              <div class="layui-card">
                <div class="layui-card-header layui-bg-black">
                  <i class="layui-icon layui-icon-group icon_font"></i>参与人数
                </div>
                <div class="layui-card-body card_padding layui-bg-red">-----------</div><!-- {{numConvert(111111)}} -->
              </div>
            </div>
            <div class="col-xl-4 col-md-6 card_margin">
              <div class="layui-card">
                <div class="layui-card-header layui-bg-black">
                  <i class="layui-icon layui-icon-date icon_font"></i>会议场次
                </div>
                <div class="layui-card-body card_padding layui-bg-orange">-----------</div>
              </div>
            </div>
            <div class="col-xl-4 col-md-6 card_margin">
              <div class="layui-card">
                <div class="layui-card-header layui-bg-black">
                  <i class="layui-icon layui-icon-rmb icon_font"></i>收入金额
                </div>
                <div class="layui-card-body card_padding layui-bg-blue">-----------</div>
              </div>
            </div>
          </div>
          <div class="row bg_white" style="position: relative;">
            <div id="myChart" class="col-xl-12" style="height:400px"></div>
            <div style="position: absolute;right:0px;top:0px;padding-top:20px;padding-right:15px;">
              <label class="layui-form-label" style="width:105px">选择日期&nbsp;:</label>
              <div class="layui-input-block">
                <input
                  type="text"
                  name="date"
                  id="moren"
                  placeholder="yyyy-MM-dd"
                  autocomplete="off"
                  class="layui-input"
                />
              </div>
            </div>
          </div>
          <div class="row bg_white" style="position: relative;padding-bottom:20px">
            <div id="my_twoChart" class="col-xl-12" style="height:400px"></div>
            <div style="position: absolute;right:0px;top:0px;padding-top:20px;padding-right:15px;">
              <label class="layui-form-label" style="width:105px">选择日期&nbsp;:</label>
              <div class="layui-input-block">
                <input
                  type="text"
                  name="date"
                  id="morens"
                  placeholder="yyyy-MM-dd"
                  autocomplete="off"
                  class="layui-input"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-md-6">
          <div style="font-size:18px;font-weight:600;padding-bottom:10px">系统通知</div>
          <div class="list">
            <ul style="padding:20px">
              <li class="list_li">
                <span>
                  <i
                    class="layui-icon layui-icon-notice"
                    style="vertical-align: middle;color:green"
                  ></i>敬请期待......
                </span>
                <span>---------</span>
              </li>
              <li class="list_li">
                <span>
                  <i
                    class="layui-icon layui-icon-notice"
                    style="vertical-align: middle;color:green"
                  ></i>敬请期待......
                </span>
                <span>---------</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      //会议人数  柱状图
      meetings_people: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      //会议收入  折线图
      meetings_income: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      //会议支出  折线图
      meetings_expenditure: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ]
    };
  },
  created() {

  },
  mounted() {
    this.drawLine();
    this.data_selet();
  },
  methods: {
    //数字转化
    numConvert(num) {
      if (num >= 10000) {
        num = Math.round(num / 1000) / 10 + "W+";
      } else if (num >= 1000) {
        num = Math.round(num / 100) / 10 + "K+";
      }
      return num;
      ine;
    },
    drawLine() {
      // 柱状图
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      myChart.setOption({
        title: { text: "近期会议" },
        tooltip: {},
        color: ["#61a0a8"],
        // legend: {
        //   data: ["利润", "支出"]
        // },
        xAxis: {
          name: "会议时间/年",
          data: [
            "1月",
            "2月",
            "3月",
            "4月",
            "5月",
            "6月",
            "7月",
            "8月",
            "9月",
            "10月",
            "11月",
            "12月"
          ]
        },
        yAxis: {
          name: "会议人数/个",
          nameLocation: "end"
        },
        series: [
          {
            name: "人数",
            type: "bar",
            data: this.meetings_people
          }
        ]
      });
      window.onresize = myChart.resize;

      // 折线图
      let myChart_tow = this.$echarts.init(
        document.getElementById("my_twoChart")
      );
      myChart_tow.setOption({
        title: { text: "会议收支分析" },
        tooltip: {},
        legend: {
          data: ["会议支出", "会议收入"],
          bottom: "1"
        },
        xAxis: {
          name: "会议时间/年",
          data: [
            "1月",
            "2月",
            "3月",
            "4月",
            "5月",
            "6月",
            "7月",
            "8月",
            "9月",
            "10月",
            "11月",
            "12月"
          ]
        },
        yAxis: {
          name: "会议收入/元",
          nameLocation: "end"
        },
        series: [
          {
            name: "会议收入",
            type: "line",
            stack: "总量",
            smooth: true,
            label: {
              show: true
            },
            data: this.meetings_income
          },
          {
            name: "会议支出",
            type: "line",
            stack: "总量",
            smooth: true,
            label: {
              show: true
            },
            data: this.meetings_expenditure
          }
        ]
      });
      window.onresize = myChart_tow.resize;
   
    },
    //图表时间选择器
    data_selet() {
      layui.use("laydate", function() {
        var laydate = layui.laydate;
        laydate.render({
          elem: "#moren"
        });
        laydate.render({
          elem: "#morens"
        });
      });
    }
  }
};
</script>
<style scoped>
.card_margin {
  margin-bottom: 20px;
}
.card_padding {
  font-size: 24px;
  text-align: center;
  line-height: 80px;
}
.icon_font {
  font-size: 24px;
  vertical-align: middle;
  margin-right: 10px;
}
.bg_white {
  background-color: white;
  padding-top: 20px;
  margin-bottom: 10px;
  border-radius: 10px;
}
.list {
  height: 500px;
  border-radius: 10px;
  background-color: white;
}

.list_li {
  font-size: 14px;
  height: 20px;
  margin-bottom: 5px;
}
.list_li span {
  display: inline-block;
}
.list_li span:nth-of-type(1) {
  width: 50%;
  float: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.list_li span:nth-of-type(2) {
  float: right;
}
</style>>

